const debugFbq = function(type, eventName, params) {
  console.log(`FBQ: ${type} event ${eventName}`, params ? params : '');
};

export default {
  init(advancedMatching = {}, debug = false) {
    if (debug) {
      window.fbq = debugFbq;
    } else {
      !(function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '165212360839027', advancedMatching);
      fbq('track', 'PageView');
    }
  },

  track(title, data) {
    const { fbq } = window;
    if (fbq) {
      fbq('track', title, data);
    }
  },

  trackCustom(event, data) {
    const { fbq } = window;
    if (fbq) {
      fbq('trackCustom', event, data);
    }
  }
};
